import { render, staticRenderFns } from "./overviewBox.vue?vue&type=template&id=d0cbcb0c&scoped=true"
import script from "./overviewBox.vue?vue&type=script&lang=js"
export * from "./overviewBox.vue?vue&type=script&lang=js"
import style0 from "./overviewBox.vue?vue&type=style&index=0&id=d0cbcb0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cbcb0c",
  null
  
)

export default component.exports